<template>
<div class="chapter">
<div class="inner_page">
<div id="title-page">
<div class="generated-style">
<p class="x2ttlpg-ttl" xml:lang="en-us">Jane Austen: Blood Persuasion</p>
<p class="x2ttlpg-au" xml:lang="en-us">Janet Mullany</p>
<p class="x2ttlpg-logo" xml:lang="en-us"><span class="generated-style"><img alt="Harper_Imprint_Logos.jpg" class="generated-style" src="images/Harper_Imprint_Logos_fmt.jpeg"/></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title_Page.vue?1ff2a397